import React from 'react';
import { Navbar } from './components/Navbar';
import { LiveTicker } from './components/LiveTicker';
import { HeroSection } from './components/HeroSection';
import { CoursesSection } from './components/CoursesSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gray-950 text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <LiveTicker data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <CoursesSection data-id="element-5" />
        <FeaturesSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <PricingSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}